import { render, staticRenderFns } from "./capacity-table.vue?vue&type=template&id=40736efa"
import script from "./capacity-table.vue?vue&type=script&lang=js"
export * from "./capacity-table.vue?vue&type=script&lang=js"
import style0 from "./capacity-table.vue?vue&type=style&index=0&id=40736efa&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40736efa')) {
      api.createRecord('40736efa', component.options)
    } else {
      api.reload('40736efa', component.options)
    }
    module.hot.accept("./capacity-table.vue?vue&type=template&id=40736efa", function () {
      api.rerender('40736efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/ssr-manage/capacity-table.vue"
export default component.exports